module.exports = __webpack_public_path__ + "face_expression_model-weights_manifest.json";